import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="bg-brand-darker py-16 sm:py-24 lg:py-32 px-5 sm:px-6" data-id="element-76">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[680px] mx-auto text-center flex flex-col items-center" data-id="element-77">
        <h2 className="text-[28px] sm:text-[36px] lg:text-[42px] font-bold text-brand-gold mb-8 sm:mb-12 leading-tight" data-id="element-78">
          La vérité que personne ne vous dit.
        </h2>

        <div className="space-y-5 sm:space-y-6 text-[16px] sm:text-[18px] text-brand-cream leading-[1.75] sm:leading-[1.8]" data-id="element-79">
          <p data-id="element-80">
            Vos clients idéaux vous cherchent en ligne. Ils trouvent votre
            profil. Et ils passent à quelqu'un d'autre.
          </p>
          <p data-id="element-81">
            Pas parce que vous n'êtes pas compétent. Parce que votre présence
            digitale ne reflète pas votre vraie valeur.
          </p>
          <p data-id="element-82">Ça vous coûte des clients. Chaque jour.</p>
          <p data-id="element-83">Et le pire? Vous ne le voyez même pas.</p>
          <p data-id="element-84">Parce que ces clients-là — ils ne vous contactent jamais.</p>
          <p data-id="element-85">Ils passent à quelqu'un d'autre en silence.</p>
        </div>
      </motion.div>
    </section>;
}